function LoadingMask() {
  return <div className="bg-gray-300 animate-pulse w-full h-4 rounded-full"></div>;
}

export default LoadingMask;
